import { grey, red } from '@mui/material/colors'

export const styles = (theme) => ({

  addButton: {
    bottom: 0,
    right: 0,
  },
  card: {
    // Wound Solutions
    // backgroundColor: '#ffe4cc',
    background: 'linear-gradient(90deg, #ffe4cc 90%, #ffe4cc 90%)',
    // background: 'linear-gradient(90deg, #ff91a3 90%, #ff91a3 90%)',
    marginLeft: 13,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    fontSize: 14,
    width: '93%',

  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    background: theme.palette.grey[500],
  },
  content: {
    color: theme.palette.grey[200],
    "@media (max-width:700px)": {
      maxWidth: '414px'
    },
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  deleteButton: {
    //		position: 'fixed',
    bottom: 0,
    left: 0,
  },
  dialogStyle: {
    "@media (max-width:700px)": {
      maxWidth: '414px'
    },
  },
  error: {
    fontSize: '20px',
    color: red[400],
  },
  fileUpload: {
    background: 'transparent',
    border: '1px solid #bbb',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'inline-block:',
    padding: theme.spacing(2),
    width: '220px',
  },
  form: {
    width: '93%',
    marginLeft: 13,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    fontSize: 14,
  },
  formSeparator1: {
    marginTop: '18pt',
    marginBottom: '6pt',
    fontSize: '16px',
  },
  formSeparator2: {
    marginTop: '24pt',
    marginBottom: '6pt',
    fontSize: '18px',
  },
  imageRoot: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  imageList: {
    marginLeft: 20,
    width: 500,
    height: 450,
  },
  marginSeparator: {
    right: theme.spacing(1),
  },
  patient: {
    inputProps: {style: {fontSize: 12}}, 
    InputLabelProps: {style: {fontSize: 10}} 
  },
  pprogress: {
    position: 'absolute',
    left: '10%',
    top: '17%',
  },
  root: {
    minWidth: 375,
    flexGrow: 1,
  },
  submitButton: {
    display: 'block',
    color: 'white',
    textAlign: 'center',
    position: 'absolute',
    right: 10,
  },
  subTitle: {
    fontSize: '24px',
    width: 93,
    color: grey[700],
    top: 20,
    bottom: 20,
    // Wound Solutions:
//    background: 'linear-gradient(45deg, #f4294bD0 30%, #fcc9d1D0 90%)',
    background: 'linear-gradient(45deg, #cb5921D0 30%, #a99787D0 90%)',
    borderRadius: '8px',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  toolbar: theme.mixins.toolbar,
  uiProgess: {
    position: 'fixed',
    zIndex: '1000',
    height: '31px',
    width: '31px',
    left: '35%',
    top: '30%',
  },
  uploadButton: {
    margin: 0,
    padding: theme.spacing(2),
    height: '56px',
    width: '220px',
  },
  uploadTitle: {
    color: grey[700],
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  viewRoot: {
    margin: 0,
    padding: theme.spacing(2),
  },
  visitGrid: {
    color: grey[900],
    // Wound Solutions
    // background: 'linear-gradient(45deg, #f4294bD0 30%, #fcc9d1D0 90%)',
    background: 'linear-gradient(45deg, #cb5921D0 30%, #a99787D0 90%)',
    borderRadius: '20px',
    overflow: 'hidden',
    '& .MuiDataGrid-main': {
      borderRadius: '20px',
      overflow: 'hidden',
    },
    '& .MuiDataGrid-columnHeaders': {
      borderTopLeftRadius: '20px',
      borderTopRightRadius: '20px',
    },
    '& .MuiDataGrid-row.Mui-selected': {
      backgroundColor: '#a17a6a !important',
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      backgroundColor: '#6e5a51 !important',
    },
  },
  ImageTitle: {
       color: grey[900],
       background: 'linear-gradient(45deg, #FFFFFFD0 30%, #FFFFFFD0 90%)',
  },
  textField: {
    backgroundColor: '#ffefe0', 
    fontSize: '25px'
  },
  visitAuthorizedRow: {
    backgroundColor: '#79a341 !important',
  },
  visitPendingRow: {
    backgroundColor: '#fbc13f !important',
  },
  visitDeclinedRow: {
    backgroundColor: '#c92118 !important',
    color: '#ffffff !important',
    '& .MuiDataGrid-cell': {
      color: '#ffffff !important',
    },
  },
  visitNotStartedRow: {
    backgroundColor: '#c08466d0 !important',
    // backgroundColor: '#ffd6d6 !important',
  },
  visitCashRow: {
    backgroundColor: '#80afc2 !important',
  },
})